// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__3o2Bt","checkmark":"styles_checkmark__14xYe","label":"styles_label__2vDJ8","input":"styles_input__2b4tG","checked":"styles_checked__3MEja"};